(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/router/assets/javascripts/handle-path.js') >= 0) return;  svs.modules.push('/components/app/router/assets/javascripts/handle-path.js');
"use strict";

const _excluded = ["children", "render"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


(svs => {
  const {
    Component
  } = React;
  const {
    matchPath,
    withRouter
  } = ReactRouterDOM;
  const logger = svs.core.log.getLogger('app:router:handle-path');
  class HandlePath extends Component {
    constructor() {
      super(...arguments);
      _defineProperty(this, "state", {
        routeMatch: null
      });
    }
    static getDerivedStateFromProps(props) {
      const {
        location,
        routesMetaData
      } = props;

      const path = Object.keys(routesMetaData).filter(path => matchPath(location.pathname, {
        path,
        exact: true
      }))[0];
      return {
        routeMatch: path ? routesMetaData[path] : null
      };
    }
    shouldComponentUpdate(nextProps, nextState) {
      const {
        location,
        role,
        authRedirect
      } = nextProps;
      const {
        routeMatch
      } = nextState;
      if (!routeMatch) {
        logger.info("".concat(location.pathname, " does not match any defined route, components are not updated."));
        return false;
      }
      svs.core.data.roles = (routeMatch.roles || []).slice();

      const hasRolePermission = routeMatch.roles && routeMatch.roles.length > 0 ? routeMatch.roles.indexOf(role) !== -1 : true;
      if (!hasRolePermission) {
        logger.info("User does not have the required permission, redirecting.");
        authRedirect();
        return false;
      }
      return true;
    }
    componentDidUpdate(prevProps, prevState) {
      const {
        routeMatch: prevRouteMatch
      } = prevState;
      const {
        routeMatch
      } = this.state;
      if (routeMatch !== prevRouteMatch) {
        if (routeMatch.title) {
          if (svs.core.data && svs.core.data.routesMetaData && svs.core.data.routesMetaData['']) {
            svs.core.data.title = svs.core.data.title || {};
            svs.core.data.title.moduleTitle = svs.core.data.routesMetaData[''].title;
          }
          document.title = this.replacePlaceholders(routeMatch.title, svs.core.data.title);
        }
        if (routeMatch.metaDescription) {
          document.querySelector('meta[name=description]').content = this.replacePlaceholders(routeMatch.metaDescription, svs.core.data.metaDescription);
        }
        if (routeMatch.metaKeywords) {
          document.querySelector('meta[name=keywords]').content = this.replacePlaceholders(routeMatch.metaKeywords, svs.core.data.metaKeywords);
        }
      }
    }
    replacePlaceholders() {
      let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const placeholders = text.match(/({{([\w-]*)}})+/g) || [];
      placeholders.forEach(placeholder => {
        text = text.replace(new RegExp(placeholder, 'g'), data[placeholder.replace(/{|}/g, '')] || '');
      });
      return text;
    }
    render() {
      const _this$props = this.props,
        {
          children,
          render
        } = _this$props,
        routeProps = _objectWithoutProperties(_this$props, _excluded);
      if (children && render) {
        throw new Error('Use children or render, not both');
      }
      return render ? render(routeProps) : children;
    }
  }
  svs.app.ReactRouter.HandlePathComponent = HandlePath;
  svs.app.ReactRouter.HandlePathContainer = withRouter(HandlePath);
})(svs);

 })(window);